module.exports = __webpack_public_path__ + "YE.png?3a76dc4edeb94c4a947b2628126dfb2e";